import { useEffect, useState } from 'react'
import firebase from '../firebase/compat'
import { client } from './Client'
import { callWithRetry } from '../helpers/callables/retryCallable'

/**
 * Is dit huishouden ook elders in het programma bekend?
 *
 * WAAROM EEN FUNCTIE EN GEEN QUERY. Elke deelname-rij draagt `Members` met
 * precies twee partijen: het programma en de organisatie zelf. Een lid kan de
 * rij van een ánder lid dus niet lezen — die is niet leeg maar geweigerd, en
 * dat is precies de bedoeling. Het antwoord op 'is dit huishouden al bekend?'
 * komt daarom server-side tot stand en is uitgekleed: aantallen en data, geen
 * CompagnyID's.
 *
 * `loaded: false` betekent 'nog niet bekend' en is iets anders dan 'niet
 * gedeeld'. Dat verschil is hier niet cosmetisch: leest een nog lopend antwoord
 * als 'geen nulmeting', dan stuurt het scherm een tweede nulmeting naar een
 * huishouden dat er al één had.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {string} adressID - `Adresses.ID` van het huishouden
 * @returns {{loaded: boolean, shared: boolean, organisationCount: number,
 *   firstRegisteredAt: number|null, baselineStarted: boolean,
 *   baselineByOther: boolean, allCompleted: boolean}}
 */
const LEEG = {
    loaded: false,
    shared: false,
    organisationCount: 0,
    firstRegisteredAt: null,
    baselineStarted: false,
    baselineByOther: false,
    allCompleted: false,
}

const useHouseholdChain = (adressID) => {
    const [chain, setChain] = useState(LEEG)

    useEffect(() => {
        if (!adressID || !client) {
            setChain(LEEG)
            return undefined
        }

        // Een antwoord van een vorig huishouden mag niet blijven staan terwijl
        // het volgende onderweg is.
        setChain(LEEG)
        let afgebroken = false

        // Regio expliciet: de standaard-client wijst naar us-central1.
        // AI-CONTEXT: See docs/pitfalls.md#api-firebase-v1-region-default
        const haalOp = firebase.app().functions('europe-west1').httpsCallable('getHouseholdChainSummary')
        // Een koude start kan het eerste verzoek afbreken ('internal'); dan
        // nog een keer, anders zwijgt het scherm tot een herlaad.
        callWithRetry(() => haalOp({ adressID, client }))
            .then(({ data }) => {
                if (!afgebroken && data) setChain(data)
            })
            .catch((error) => {
                // Stil verdwijnen mag niet, maar het scherm mag ook niets
                // beweren: `loaded` blijft false, dus de melding blijft weg.
                console.error('Ketenoverzicht van dit huishouden kon niet worden opgehaald', { adressID }, error)
            })

        return () => { afgebroken = true }
    }, [adressID])

    return chain
}

export default useHouseholdChain
